package com.patronat.top.ui.models

/**
 * Фото для галереї закладу. Незалежно від джерела (сервер/нове завантаження),
 * у UI відображається за URL.
 */
data class VenueGalleryPhoto(
    val id: String,
    val imageUrl: String
)
